<script setup lang="ts">
import { withTrailingSlash } from 'ufo'
import { toArticles } from '~/types/article'

const props = defineProps({
  path: {
    type: String,
    default: 'posts',
  },
})

const { data: _articles } = await useAsyncData(
  props.path,
  async () =>
    toArticles(await queryContent(withTrailingSlash(props.path)).sort({ date: -1 }).find()),
)

const articles = computed(() => _articles.value || [])
</script>

<template>
  <div v-if="articles?.length">
    <div class="featured my-12 md:my-8">
      <ArticlesListItemV2 :article="articles[0]" :featured="true" />
    </div>
    <div class="grid grid-cols-1 gap-12 md:grid-cols-2 md:gap-8 lg:grid-cols-3">
      <ArticlesListItemV2
        v-for="(article, index) in articles.slice(1)"
        :key="index"
        :article="article"
      />
    </div>
  </div>
  <div
    v-else
    class="min-h-[30vh] flex flex-col items-center justify-center text-center text-gray-600 dark:text-gray-400"
  >
    <p>Seems like there are no articles yet.</p>
    <p>
      You can start by adding markdown files in the
      <code class="text-sm bg-gray-100 dark:bg-gray-800 px-1 rounded">content/posts</code>
      folder.
    </p>
  </div>
</template>
